import { setError } from "@/actions/message";
import { changePassword } from "@/actions/users.actions";
import InputError from "@/components/core/InputError";
import { useLocationContext } from "@/context/LocationContext";
import { UserContext } from "@/context/UserContext";
import { ChangePasswordDto } from "@/data/dtos/change-password.dto";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Security() {
  const dispatch = useDispatch();
  const [passwordForm, setPasswordForm] = useState<ChangePasswordDto>({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const { message } = useSelector((state: any) => state.message);
  const userContext = useContext(UserContext);
  if (!userContext) {
    throw new Error("UserContext must be used within a UserProvider");
  }
  const { user } = userContext;
  const locationContext = useLocationContext();
  const navigator = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPasswordForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePasswordChangeSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Form Data Submitted:", passwordForm);
    if (user?._id) {
      if (passwordForm.newPassword !== passwordForm.confirmPassword) {
        return dispatch(
          setError({
            message: "Sifreler uyuşmuyor",
            errors: {
              newPassword: { errors: ["Sifreler uyuşmuyor"] },
              confirmPassword: { errors: ["Sifreler uyuşmuyor"] },
            },
          })
        );
      }
      dispatch(changePassword(user?._id, passwordForm) as any);
      navigator(locationContext.previousPath || "/");
    } else {
      dispatch(setError("Kullanıcı bulunamadı"));
    }
  };

  return (
    <div className="h-[90vh] justify-center flex flex-col">
      <Container maxWidth="sm" className="mt-4 rounded shadow p-4 bg-white ">
        <Typography variant="h5" component="h1" gutterBottom>
          Şifremi Güncelle
        </Typography>
        <form onSubmit={handlePasswordChangeSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} className="relative">
              <TextField
                fullWidth
                label="Mevcut Şifre"
                name="currentPassword"
                type={showPassword ? "text" : "password"}
                value={passwordForm.currentPassword}
                onChange={handlePasswordChange}
                variant="outlined"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />

              <InputError
                messages={message?.errors?.currentPassword}
                className="mt-2"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Yeni Şifre"
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                value={passwordForm.newPassword}
                onChange={handlePasswordChange}
                variant="outlined"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <InputError
                messages={message?.errors?.newPassword}
                className="mt-2"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Yeni Şifre Tekrarı"
                name="confirmPassword"
                value={passwordForm.confirmPassword}
                onChange={handlePasswordChange}
                type={showConfirmPassword ? "text" : "password"}
                variant="outlined"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <InputError
                messages={message?.errors?.confirmPassword}
                className="mt-2"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                ŞİFREYİ KAYDET
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </div>
  );
}
